<template>
  <rt-dialog
    ref="dialog"
    v-model="visible"
    :append-to-body="true"
    :title="title"
    class="lookup-dialog"
    :size="size"
  >
    <rt-row
      :gutter="0"
      class="lookup-row"
    >
      <rt-col :span="leftRatio">
        <rt-section title=" ">
          <div slot="btn">
            <rt-search
              v-if="tableSearch"
              v-model="queryValue"
              :clearable="clearable"
              :more="false"
              @on-search="search"
              @clear="clearQueryValue"
            />
          </div>
          <rt-table
            ref="table"
            :keep-selected="keepSelected"
            :fetch="fetchData"
            :page-size="10"
            :class="{ 'is-single': !multiple }"
            :total-record="total"
            :row-key="getRowKeys"
            page-layout="total, prev, pager, next"
            class="rt-table-aside"
            @select="select"
            @select-all="selectAll"
            @row-click="onTableRowClick"
            @load-complete="onTableLoadComplete"
          >
            <rt-table-column
              v-for="(item, index) in displayFields"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            />
          </rt-table>
        </rt-section>
      </rt-col>
      <rt-col :span="rightRatio">
        <rt-card
          v-if="multiple"
          ref="lookupDrawer"
          :class="column ? 'column-card' : ''"
        >
          <rt-button
            v-if="!column"
            :icon-name="showDrawer ? 'rt-base-close-x' : 'rt-base-angle-left-filled'"
            :class="unfoldText ? '' : 'icon-btn'"
            type="primary"
            size="small"
            class="drawer-btn"
            @click="onDrawer"
          >
            {{ unfoldText ? $tx('已选', 'xpc.common.selected') : '' }}
          </rt-button>
          <rt-search
            v-if="drawerSearch"
            v-model="selectValue"
            :more="false"
            :clearable="clearable"
            class="select-search"
            @on-search="searchSelect"
            @clear="clearSearchValue"
          />
          <div
            v-if="isSearch"
            class="select-num"
          >
            {{
              $tx(`已选择 ${selectList.length} 项，为你搜到 ${searchList.length} 项`, 'xpc.lookup.searchItems', {
                count: selectList.length, search: searchList.length
              })
            }}
          </div>
          <div
            v-else
            class="select-num"
          >
            {{
              $tx(`已选择 ${selectList.length} 项`, 'xpc.lookup.selectedItems', {
                count: selectList.length
              })
            }}
          </div>

          <div class="tag-content">
            <rt-tag
              v-for="(item, index) in searchList"
              :key="item[alias.id]"
              type="outline"
              closable
              @close="delTag(index, item)"
            >
              {{ item[alias.name] }}
            </rt-tag>
            <rt-default-image
              v-show="selectList.length === 0"
              style="margin-top: 50%"
            >
              <div slot="describe">
                {{ $tx('暂无数据', 'xpc.uploadfile.nodata') }}
              </div>
            </rt-default-image>
          </div>
        </rt-card>
      </rt-col>
    </rt-row>

    <div
      slot="footer"
      class="rt-dialog-footer-buttons"
    >
      <rt-button
        v-if="selectList.length"
        @click="clear"
      >
        <span v-if="multiple">{{ $tx('移除值', 'xpc.dialog.multipleClear') }}</span>
        <span v-else>{{ $tx('移除值', 'xpc.dialog.singleClear') }}</span>
      </rt-button>
      <rt-button
        type="primary"
        @click="confirm"
      >
        {{ $tx('确认', 'xpc.dialog.confirm') }}
      </rt-button>
    </div>
  </rt-dialog>
</template>
<script>
import RtSection from '../section/rtSection';
import RtSearch from '../search/rtSearch';
import RtTable from '../table/rtTable';
import RtTableColumn from '../table/rtTableColumn';
import RtCard from '../card/rtCard.vue';
import RtButton from '../button/rtButton.vue';
import RtRow from '../row/rtRow.vue';
import RtCol from '../col/rtCol.vue';
import RtTag from '../tag/rtTag.vue';
import RtDefaultImage from '../defaultImage/rtDefaultImage.vue';
import RtDialog from '../dialog/rtDialog';

const copyObj = obj => (obj ? JSON.parse(JSON.stringify(obj)) : '');

export default {
  name: 'RtLookupView',
  components: {
    RtSection,
    RtSearch,
    RtTable,
    RtTableColumn,
    RtCard,
    RtButton,
    RtRow,
    RtCol,
    RtTag,
    RtDefaultImage,
    RtDialog
  },
  props: {
    column: {
      type: Boolean,
      default: false
    },
    // 左右布局比例
    ratio: {
      type: String,
      default: '2:1'
    },
    // 按钮文字隐藏
    unfoldText: {
      type: Boolean,
      default: true
    },
    drawerSearch: {
      type: Boolean,
      default: true
    },
    tableSearch: {
      type: Boolean,
      default: true
    },
    fetch: {
      type: Function,
      required: true
    },
    alias: {
      type: Object
    },
    multiple: {
      type: Boolean,
      default: false
    },
    displayFields: {
      type: Array,
      default () {
        return [];
      }
    },
    title: String,
    /**
     * @public 表格数据总数
     */
    total: Number,
    /**
     * 是否需要保持选中项在翻页的时候
     */
    keepSelected: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default () {
        return [];
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * @public 弹窗尺寸
     */
    size: {
      type: String,
      default: 'large'
    },
    /**
     * @public 请求参数的字段名
     */
    pageFields: {
      type: Object,
      default () {
        return { }
      }
    }
  },
  data () {
    return {
      queryValue: '',
      showDrawer: false,
      selectList: [...this.list],
      selectValue: '',
      deleteList: [],
      // 搜索后 tag
      searchList: [],
      // 是否搜索
      isSearch: false,
      // dialog是否显示
      visible: false
    };
  },
  computed: {
    ratioNum () {
      let total = parseInt(this.ratio.split(':')[0]) + parseInt(this.ratio.split(':')[1]);
      return 24 / total;
    },
    leftRatio () {
      if (!this.multiple || !this.column) {
        return 24;
      } else {
        return parseInt(this.ratio.split(':')[0]) * this.ratioNum;
      }
    },
    rightRatio () {
      return 24 - this.leftRatio;
    },
    innerPageFields () {
      return {
        pageSize: 'pageSize',
        pageIndex: 'pageIndex',
        queryValue: 'queryValue',
        ...this.pageFields
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.selectList = [...this.list];
        this.searchList = [];
      }
    }
  },

  destroyed () {
    this.timer && clearTimeout(this.timer);
  },

  methods: {
    clearQueryValue () {
      this.search();
    },
    clearSearchValue () {
      this.afterSearchTag();
      this.isSearch = false;
    },
    onDrawer () {
      if (this.$refs.lookupDrawer.$el.style.right === '0px') {
        this.$refs.lookupDrawer.$el.style.right = '-30%';
        this.showDrawer = false;
        return;
      }
      this.showDrawer = true;
      this.$refs.lookupDrawer.$el.style.right = '0px';
    },
    /**
     * @private
     * 搜索后选项
     */
    afterSearchTag () {
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let selection = copyObj(
          this.$refs.table && this.$refs.table.$children[0] && this.$refs.table.$children[0].selection
        );
        this.selectList = selection;
        this.searchList = this.selectList;
      });
    },
    // 删除已选择项
    delTag (index, item) {
      if (!this.selectValue) {
        this.selectList.splice(index, 1);
        this.searchList = this.selectList;
      } else {
        // 删除 selectList 包括 deleteSearchList 的项
        this.selectList = this.selectList.filter(data => item[this.alias.id] !== data[this.alias.id]);

        this.searchList.splice(index, 1);
      }

      this.deleteList.push(item);
      if (this.searchList.length === 0) {
        this.afterSearchTag();
        this.selectValue = '';
        this.isSearch = false;
      }

      this.$nextTick(() => {
        this.$refs.table.toggleRowSelection(item, false);
      });
    },
    // 搜索已选项
    searchSelect () {
      if (!this.selectValue) {
        this.afterSearchTag();
        this.isSearch = false;
      } else {
        this.isSearch = true;
      }
      let selected = copyObj(this.selectList);
      selected = selected.filter(item => {
        this.$refs.table.toggleRowSelection(item, true);
        return item[this.alias.name].indexOf(this.selectValue) >= 0;
      });
      this.searchList = selected;
    },
    getRowKeys (row) {
      return row[this.alias.id];
    },
    search () {
      this.lodaData();
    },
    // 加载数据
    lodaData () {
      this.$refs.table.clearSelection();
      this.$refs.table.loadData();
    },
    fetchData ({ pageIndex, pageSize }) {
      const params = {};
      params[this.innerPageFields.pageIndex] = pageIndex;
      params[this.innerPageFields.pageSize] = pageSize;
      params[this.innerPageFields.queryValue] = this.queryValue;

      return this.fetch(params);
    },
    /**
     * @private 点击表格的checkbox
     * @param {Array} selection 所有选中项
     * @param {Object} row 当前选中项
     */
    select (selection, row) {
      this.onTableRowClick(row);
    },
    /**
     * @private 点击表格的全选
     * @param {Array} selection 所有选中项
     */
    selectAll (selection) {
      this.selectList = [...selection];
      this.searchList = [...selection];

      this.$emit('change', {
        data: copyObj(selection),
        multiple: true
      });
    },
    /**
     * @private 表格行点击
     * @param {Object} 当前点击行的数据
     */
    onTableRowClick (row, column, cell, event) {
      let selected = copyObj(this.selectList);

      if (!this.multiple) {
        if (selected && selected[0] && this.getRowKeys(selected[0]) === this.getRowKeys(row)) {
          selected = null;
          this.selectList = [];
          this.$refs.table.clearSelection();
        } else {
          selected = row;
          this.$refs.table.clearSelection();
          this.$refs.table.toggleRowSelection(selected);
          this.selectList = [selected];
        }
      } else {
        if (selected && selected.length > 0) {
          const index = selected.findIndex(v => this.getRowKeys(v) === this.getRowKeys(row));
          if (index >= 0) {
            selected.splice(index, 1);
          } else {
            selected.push(row);
          }
        } else {
          selected.push(row);
        }
        this.selectList = selected;
        this.searchList = selected;
      }

      this.$emit('change', {
        data: copyObj(selected),
        multiple: this.multiple
      });
    },
    /**
     * @private 表格数据加载完成
     */
    onTableLoadComplete () {
      if (!this.keepSelected) {
        this.selectList = [];
        this.searchList = [];
      } else {
        this.searchList = this.selectList;
        let selected = copyObj(this.selectList);

        this.$refs.table.dataList.forEach(item => {
          if (selected.some(d => this.getRowKeys(d) === this.getRowKeys(item))) {
            this.$refs.table.toggleRowSelection(item, true);
          }
        });
        this.selectList.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true);
        });
      }
    },
    clear () {
      this.selectList = [];
      this.searchList = [];
      this.$refs.table.clearSelection();
      this.$emit('cancel');
    },
    confirm () {
      this.$refs.dialog.confirm();
      const selected = this.multiple ? this.selectList : this.selectList[0];
      this.$emit('confirm', selected);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLookupView.vue?a2baca46